import { applyReducers } from 'redux/helpers';
import * as actions from './actions';
import currentStatus from './currentStatus/reducer';

export default (previosState = {}, action) => {
  const state = applyReducers({ currentStatus }, previosState, action);

  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        projectId: action.projectId,
      };
    case actions.INIT.END:
      return {
        ...state,
        statusOptions: action.statusOptions,
        colors: action.colors,
        statusBehaviours: action.statusBehaviours,
        statuses: action.statuses,
        changes: 0,
      };
    case actions.ADD.END:
    case actions.REMOVE.END:
      return {
        ...state,
        statusOptions: action.statusOptions,
      };
    case actions.INVALIDATE:
      return {
        ...state,
        statusOptions: action.statusOptions,
        changes: action.changes,
      };
    case actions.INVALIDATE_SERVER.END:
      return {
        ...state,
        statusOptions: action.statusOptions,
        statuses: action.statuses,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/status/reducer.js